import { TriangleAlert } from 'lucide-react';

import { DarkButton } from '@/components/ui/dark-button';
import { GlassCard } from '@/components/ui/glass-card';

interface ErrorPanelProps {
  title: string;
  message: string;
  /** Backend request id, shown so a user can quote it in a bug report. */
  requestId?: string;
  onRetry?: () => void;
  onBack?: () => void;
}

/** Terminal error state with the two recoveries that ever make sense. */
export function ErrorPanel({
  title,
  message,
  requestId,
  onRetry,
  onBack,
}: ErrorPanelProps) {
  return (
    <GlassCard role="alert" className="w-full max-w-md rounded-3xl p-8 text-center">
      <div
        className="mx-auto mb-4 grid size-12 place-items-center rounded-full bg-hangup/15 text-hangup"
        aria-hidden="true"
      >
        <TriangleAlert className="size-6" aria-hidden="true" />
      </div>

      <h2 className="text-xl font-semibold tracking-tight text-balance text-call-ink">
        {title}
      </h2>
      <p className="mt-2 text-[0.9375rem] leading-relaxed text-call-dim">{message}</p>

      <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
        {onRetry && (
          <DarkButton type="button" onClick={onRetry}>
            Try again
          </DarkButton>
        )}
        {onBack && (
          <DarkButton type="button" variant="secondary" onClick={onBack}>
            Back to home
          </DarkButton>
        )}
      </div>

      {requestId && (
        <p className="mt-6 text-xs text-call-dim/70">
          Reference:{' '}
          <code className="rounded bg-white/10 px-1.5 py-0.5 font-mono">
            {requestId}
          </code>
        </p>
      )}
    </GlassCard>
  );
}
